import { render, staticRenderFns } from "./WalletCard.vue?vue&type=template&id=e1451da0&scoped=true"
import script from "./WalletCard.vue?vue&type=script&lang=js"
export * from "./WalletCard.vue?vue&type=script&lang=js"
import style0 from "./WalletCard.vue?vue&type=style&index=0&id=e1451da0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1451da0",
  null
  
)

export default component.exports